module.exports = __webpack_public_path__ + "img/amex.2fe026ad.svg";